<template>
	<loading
		:active.sync="isLoading"
		:can-cancel="false"
		:is-full-page="true"
		background-color="#000000"
		blur=""
		color="#0068B4"
		:opacity="0.4"
	></loading>
</template>
<script>
import Loading from 'vue-loading-overlay';

export default {
	name: 'LoadingScreen',
	components: { Loading },
	props: {
		isLoading: {},
	},
};
</script>
<style lang="sass">

.vld-shown
  overflow: hidden

.vld-overlay
  bottom: 0
  left: 0
  position: absolute
  right: 0
  top: 0
  align-items: center
  display: none
  justify-content: center
  overflow: hidden
  z-index: 9999

.vld-overlay.is-active
  display: flex

.vld-overlay.is-full-page
  z-index: 9999
  position: fixed

.vld-overlay .vld-background
  bottom: 0
  left: 0
  position: absolute
  right: 0
  top: 0
  background: #fff
  opacity: 0.5

.vld-overlay .vld-icon, .vld-parent
  position: relative
</style>
